import React, { forwardRef, ForwardRefRenderFunction, useEffect, useState } from 'react';
import {
  SpecialPriceHeaderProp,
  SpecialPriceHeaderRef,
} from '@/pages/specialPriceTable/specialPriceApproval/components/specialPriceApprovalHeader/type';
import { Box, Button, ButtonGroup, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { BaseTextFieldSize, MarginTextTop, SxWidth } from '@/styles';
import {
  SearchSpecialPrickHeaderTableRequest,
} from '@/services/api/specialPriceTable/message/SearchSpecialPrickHeaderTableRequest';
import dayjs from 'dayjs';
import DateInfo from 'src/components/desktopDatePickerInfo';
import OutlinedInput from '@mui/material/OutlinedInput';
import { SpecialPrickTypeEnum } from '@/services/api/specialPriceTable/types';
import { HasDiscountTableDownloadPermissionApi } from '@/services/api/specialPriceTable';

const SpecialPriceHeaderHeader:
    ForwardRefRenderFunction<SpecialPriceHeaderRef, SpecialPriceHeaderProp> = (props, ref) => {
      const { SpecialPriceApprovalLoad, OutPdfExcelClick } = props;

      const [viewModel, setViewModel] = useState<SearchSpecialPrickHeaderTableRequest>({
        CreateDateEnd: dayjs().add(1, 'day'),
        CreateDateStart: dayjs().subtract(30, 'day'),
        SalesNameLike: '',
        Type: null,
        Page: {
          Limit: 10,
          Page: 0,
        },
      });

      const [outExcelClick, setOutExcelClick] = useState<boolean>(false);

      useEffect(() => {
        HasDiscountTableDownloadPermissionApi({}).then(data => {
          if (data === undefined || data?.Data === false || data?.Data === undefined) {
            setOutExcelClick(true);
          } else if (data?.Data === true) {
            setOutExcelClick(false);
          }
        });
      }, []);

      return (
        <Grid container spacing={2}>
            <Grid item xs={2}>
                <FormControl style={MarginTextTop} size={BaseTextFieldSize} fullWidth>
                    <InputLabel id="demo-multiple-name-label">Type</InputLabel>
                    <Select
                        labelId="Type"
                        id="Type"
                        value={viewModel.Type}
                        label="Type"
                        onChange={(e) => {
                          viewModel.Type = e.target.value as SpecialPrickTypeEnum;
                          console.log('viewModel.Type', viewModel.Type);
                          console.log('viewModel', viewModel);
                          setViewModel({ ...viewModel });
                        }}
                    >
                        <MenuItem value={0}> </MenuItem>
                        <MenuItem value={1}>司机带</MenuItem>
                        <MenuItem value={2}>寄出去</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={2}>
                <Box sx={{ width: '100%' }} style={MarginTextTop}>
                    <TextField id="sales-name-text"
                               value={viewModel.SalesNameLike}
                               label="SalesName"
                               size={BaseTextFieldSize}
                               sx={SxWidth}
                               variant="outlined"
                               onChange={(e) => {
                                 viewModel.SalesNameLike = e.target.value;
                                 setViewModel({ ...viewModel });
                               }}
                    />
                </Box>
            </Grid>
            <Grid item xs={2}>
                <Box sx={{ width: '100%' }}>
                    <DateInfo
                        DefaultValue={viewModel.CreateDateStart}
                        Label={'CreateDateStart'}
                        OnChange={(e) => {
                          viewModel.CreateDateStart = e;
                          setViewModel({ ...viewModel });
                        }}>
                    </DateInfo>
                </Box>
            </Grid>
            <Grid item xs={2}>
                <Box sx={{ width: '100%' }}>
                    <DateInfo
                        DefaultValue={viewModel.CreateDateEnd}
                        Label={'CreateDateEnd'}
                        OnChange={(e) => {
                          viewModel.CreateDateEnd = e;
                          setViewModel({ ...viewModel });
                        }}>
                    </DateInfo>
                </Box>
            </Grid>
            <Grid item xs={2}>
                <Box sx={{ width: '100%' }} style={MarginTextTop}>
                    <ButtonGroup>
                        <Button onClick={() => SpecialPriceApprovalLoad({ ...viewModel })}>
                            Load
                        </Button>
                        <Button onClick={() => {
                          viewModel.SalesNameLike = '';
                          viewModel.CreateDateStart = null;
                          viewModel.CreateDateEnd = null;
                          viewModel.Type = null;
                          SpecialPriceApprovalLoad({ ...viewModel });
                          setViewModel({ ...viewModel });
                        }}>
                            Reset
                        </Button>

                        <Button disabled={outExcelClick} onClick={() => OutPdfExcelClick({
                          CreateDateStart: viewModel.CreateDateStart,
                          CreateDateEnd: viewModel.CreateDateEnd,
                          SalesNameLike: viewModel.SalesNameLike,
                          Type: viewModel.Type,
                        })}>
                            OutExcel
                        </Button>
                    </ButtonGroup>
                </Box>

            </Grid>
        </Grid>
      );
    };

export default forwardRef(SpecialPriceHeaderHeader);
